import React from 'react';

export default function Error({ message }) {
	return <div id="Error">{message}</div>;
}
